var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8HammerAndAnvil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "X1SnPmDj6_B5gNGqkmhHoa",
    x1: 22.138,
    x2: 27.065,
    y1: 36.528,
    y2: 50.063,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 17",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X1SnPmDj6_B5gNGqkmhHoc",
    x1: 21.636,
    x2: 29.141,
    y1: 20.973,
    y2: 41.592,
    gradientTransform: "rotate(-90 25 30.5)",
    xlinkHref: "#X1SnPmDj6_B5gNGqkmhHoa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X1SnPmDj6_B5gNGqkmhHod",
    x1: 8.557,
    x2: 8.557,
    y1: -1071.406,
    y2: -1088.064,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 76",
    gradientTransform: "rotate(135 -208.353 -528.172)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X1SnPmDj6_B5gNGqkmhHob",
    x1: 5.818,
    x2: 23.112,
    y1: -1059.626,
    y2: -1076.919,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 23",
    gradientTransform: "rotate(135 -208.353 -528.172)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X1SnPmDj6_B5gNGqkmhHoe",
    x1: 13.124,
    x2: 19.556,
    y1: 24.376,
    y2: 17.944,
    xlinkHref: "#X1SnPmDj6_B5gNGqkmhHob"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 6,
    x: 19,
    y: 34,
    fill: "#64717c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M5.75058,28H11a0,0,0,0,1,0,0v5.00408a0,0,0,0,1,0,0H9.25349A4.25349,4.25349,0,0,1,5,28.75059v0A.75058.75058,0,0,1,5.75058,28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X1SnPmDj6_B5gNGqkmhHoa)",
    d: "M14,43.35014A4.30729,4.30729,0,0,1,18.26314,39H30.73686A4.30729,4.30729,0,0,1,35,43.35014h0A.64346.64346,0,0,1,34.36314,44h-4.4628a.68054.68054,0,0,1-.59995-.43187c-.45686-.97646-2.43249-1.711-4.80039-1.711s-4.34353.73453-4.80039,1.711A.68054.68054,0,0,1,19.09966,44h-4.4628A.64346.64346,0,0,1,14,43.35014Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X1SnPmDj6_B5gNGqkmhHoc)",
    d: "M21.19231,15.5h0A8.30768,8.30768,0,0,1,29.5,23.80768v20.3077A1.38462,1.38462,0,0,1,28.11538,45.5H21.88462A1.38462,1.38462,0,0,1,20.5,44.11538V16.19231A.69231.69231,0,0,1,21.19231,15.5Z",
    transform: "rotate(90 25 30.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M13.5,21.5h5V20.001a1.001,1.001,0,0,1,0-2.002V16.5h-5v1.506a.994.994,0,1,1,0,1.988Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X1SnPmDj6_B5gNGqkmhHod)",
    d: "M18.7123,16.99151,36,17a1,1,0,0,0,1-1V13.00849a1.00294,1.00294,0,0,0-1-1L25.18212,12H18.7123Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X1SnPmDj6_B5gNGqkmhHob)",
    d: "M13.5,18h5a.5.5,0,0,0,.5-.5v-6a.5.5,0,0,0-.5-.5H17l-.84634-1.99763A5.39364,5.39364,0,0,1,17.197,4.07274l.871-1.04553a.626.626,0,0,0-.03812-.84388h0a.62617.62617,0,0,0-.8854,0L15.10588,4.22188A7.18991,7.18991,0,0,0,13,9.30591V17.5A.5.5,0,0,0,13.5,18Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 13,
    y: 20,
    fill: "url(#X1SnPmDj6_B5gNGqkmhHoe)",
    rx: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8HammerAndAnvil);
export default __webpack_public_path__ + "static/media/icons8-hammer-and-anvil.4d8bf8f3350d28609a7d8bdb4e6a8664.svg";
export { ForwardRef as ReactComponent };